export enum TransactionStatus {
    OPEN = 'OPEN',
    CLOSE = "CLOSE"
}
export enum TransactionPaymentType {
    Full_Payment = ' Full Payment',
    Part_Payment  = "Part Payment "
}
